import React, { useEffect } from "react";
import "../assets/home.css";
import { initScrollAnimations } from "./HomeAnimations";
import demo from "../assets/demo.png"
import { Link } from "react-router-dom";

const Home = () => {

    useEffect(() => {
        initScrollAnimations();
    }, []);

    return (
        <>

            {/* HERO */}

            <section className="hero">
                <div className="container hero-grid">

                    <div className="hero-left fade-up">

                        <h1>Global Reach. Complete Solutions.</h1>

                        <p>
                            Delivering reliable international business services with
                            precision, integrity and global expertise.
                        </p>

                        <div className="hero-buttons">
                            <Link to="/services" className="primary-btn">
                                Explore Services</Link>
                            <Link to="/contact" className="secondary-btn">Contact Us</Link>
                        </div>

                    </div>

                    <div className="hero-right fade-up">

                        <img
                            src="https://images.unsplash.com/photo-1553877522-43269d4ea984"
                            alt="business"
                        />

                    </div>

                </div>
            </section>


            {/* STATS */}

            <section className="stats-section">
                <div className="container stats-grid">

                    <div className="stat">
                        <h3 data-count="120">0</h3>
                        <p>Global Clients</p>
                    </div>

                    <div className="stat">
                        <h3 data-count="15">0</h3>
                        <p>Countries Served</p>
                    </div>

                    <div className="stat">
                        <h3 data-count="8">0</h3>
                        <p>Years Experience</p>
                    </div>

                    <div className="stat">
                        <h3 data-count="250">0</h3>
                        <p>Projects Delivered</p>
                    </div>

                </div>
            </section>


            {/* CLIENT LOGOS */}

            <section className="clients-section">
                <div className="container">

                    <h2>Trusted By Global Companies</h2>

                    <div className="clients-grid">

                        <img className="client-icon" src={demo} />
                        <img className="client-icon" src={demo} />
                        <img className="client-icon" src={demo} />
                        <img className="client-icon" src={demo} />
                        <img className="client-icon" src={demo} />
                        <img className="client-icon" src={demo} />

                    </div>

                </div>
            </section>


            {/* SERVICES */}

            <section className="section section-grey">
                <div className="container">

                    <h2>Our Core Services</h2>

                    <div className="services-grid">

                        <div className="service-card fade-up">
                            <div className="service-icon">📊</div>
                            <h3>Tax & Accounting</h3>
                            <p>Australia & USA taxation, bookkeeping and compliance.</p>
                        </div>

                        <div className="service-card fade-up">
                            <div className="service-icon">🛒</div>
                            <h3>E-Commerce</h3>
                            <p>Marketplace optimization and store management.</p>
                        </div>

                        <div className="service-card fade-up">
                            <div className="service-icon">💻</div>
                            <h3>Web Development</h3>
                            <p>Corporate websites and digital platforms.</p>
                        </div>

                        <div className="service-card fade-up">
                            <div className="service-icon">📈</div>
                            <h3>Business Consulting</h3>
                            <p>Strategic planning and operational optimization.</p>
                        </div>

                    </div>

                </div>
            </section>


            {/* ABOUT */}

            <section className="section">
                <div className="container about-grid">

                    <div className="about-img fade-up">
                        <img src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d" />
                    </div>

                    <div className="about-text fade-up">

                        <h2>About Sibora Global</h2>

                        <p>
                            Sibora Global delivers international business solutions
                            across finance, technology and digital transformation.
                        </p>

                        <p>
                            Our mission is to help companies expand globally
                            with reliable financial and technology services.
                        </p>

                        <Link to="/about" className="primary-btn">Learn More</Link>

                    </div>

                </div>
            </section>


            {/* WHY */}

            <section className="section section-grey">
                <div className="container">

                    <h2>Why Choose Us</h2>

                    <div className="why-grid">

                        <div className="why-card fade-up">
                            <h3>Global Expertise</h3>
                            <p>Serving international markets with deep experience.</p>
                        </div>

                        <div className="why-card fade-up">
                            <h3>Reliable Execution</h3>
                            <p>Consistent delivery with high accuracy.</p>
                        </div>

                        <div className="why-card fade-up">
                            <h3>Strategic Growth</h3>
                            <p>Solutions designed for long-term success.</p>
                        </div>

                        <div className="why-card fade-up">
                            <h3>Client Focus</h3>
                            <p>Dedicated partnership and support.</p>
                        </div>

                    </div>

                </div>
            </section>


            {/* CTA */}

            <section className="cta-section">

                <div className="container">

                    <h2>Ready to Scale Your Business?</h2>

                    <p>Partner with Sibora Global to expand confidently.</p>

                    <Link to="/contact" className="primary-btn">
                        Get Started Today
                    </Link>

                </div>

            </section>

        </>
    );
};

export default Home;